import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const TextRankItem = styled.li`
  .btn {
    width: 100%;
    height: 32px;
    ${mixin.flex({ justify: 'flex-start' })};
  }

  .text-box {
    ${mixin.flex({ justify: 'flex-start' })};
    color: #7b7b7b;
  }

  .text {
    text-align: left;
    line-height: 130%;
  }

  @media ${({ theme }) => theme.media.smMax} {
    .btn {
      height: ${mixin.pxToVw('32')};
    }
  }
`;

export const Rank = styled.span`
  display: inline-block;
  min-width: 14px;
  font-size: 14px;
  margin-right: 10px;
  color: #262626;
  font-weight: 500;

  @media ${({ theme }) => theme.media.smMax} {
    min-width: ${mixin.pxToVw('14')};
    font-size: ${mixin.pxToVw('14')};
    margin-right: ${mixin.pxToVw('10')};
  }
`;

export const New = styled.span`
  display: inline-block;
  font-size: 12px;
  margin-left: 6px;
  color: #ff4600;

  @media ${({ theme }) => theme.media.smMax} {
    font-size: ${mixin.pxToVw('12')};
    margin-left: ${mixin.pxToVw('6')};
  }
`;
